import { appRoutes } from "../../constants/appRoutes";

export const loginRoute = {
    path: appRoutes.login.path,
    lazy: () => import("../../pages/Login"),
}